<template>
  <forms-list-activity :form-type="FORM_TYPE" ref="formList"
                       @add="customAdd"
                       @details="customDetails"
                       :column-mixins="columnMixins"
                       :context="context"

  >
  </forms-list-activity>
</template>

<script>
import Activity from "@/activity/Activity";
import PermissionsSet from "@/server/PermissionsSet";
import Log from "@/utils/Log";
import DialogManager from "@/utils/DialogManager";
import FormsListActivity from "@/activity/templates/layouts/forms/FormsListActivity";
import FormsLoader from "@/components/forms/FormsLoader";
import BookHealthcheck from "@/server/com/silkplm/model/healthcheck/BookHealthcheck";
import ColumnMixin from "@/components/forms/customizations/mixins/ColumnMixin";
import FormsListContext from "@/activity/templates/layouts/forms/FormsListContext";

const FORM_TYPE = BookHealthcheck;

export default {
  name: "BookHealthcheckList",
  components: {FormsListActivity},
  permission: () => FormsLoader.formPermission(FORM_TYPE),

  async created(){
  },

  methods: {
    ...Activity.methods,

    getTitle() {
      return this.$refs.formList?.getTitle() ?? "Title in case of null";
    },


    async customAdd(){
      Log.debug("Wow!");
      //await DialogManager.info("New clicked", "A new button was clicked");
    },

    async customDetails(){
      Log.debug("Wow!");
      //await DialogManager.info("New clicked", "A new button was clicked");
    },



  },
  data:function(){return {
    FORM_TYPE,
    unsavedChanges: false,
    permissions: new PermissionsSet(),

    /** @type {[ColumnMixin]}*/
    columnMixins: [
        new ColumnMixin('title', {
          prop: 'mixinField',
          name: "MixinField"
          // template
        })
      ]
  }},
  props:{
    context:{default: null},
  }
}
</script>
